import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Sparkle, BookOpenText } from "@phosphor-icons/react";
import { SectionTitle } from "@/components/ProfileWidgets";

export default function Recommendations() {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/me/recommendations")
      .then(r => setItems(r.data))
      .catch(() => setItems([]))
      .finally(() => setLoaded(true));
  }, []);

  if (!loaded || items.length === 0) return null;

  return (
    <div data-testid="recommendations">
      <SectionTitle title="RECOMENDADOS PARA TI" more={{ label: "Ver base de dados", to: "/database" }} />
      <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 gap-4">
        {items.map((m) => (
          <Link key={m.manga_id} to={`/manga/${m.slug || m.manga_id}`} className="group" data-testid={`rec-${m.manga_id}`}>
            <div className="aspect-[2/3] overflow-hidden rounded-xl bg-[#121217] border border-white/5 relative">
              {m.cover_url ? (
                <img src={m.cover_url} alt={m.title} className="manga-cover w-full h-full object-cover" />
              ) : (
                <div className="w-full h-full grid place-items-center text-zinc-700"><BookOpenText size={22} weight="duotone" /></div>
              )}
            </div>
            <div className="mt-2 font-display font-semibold text-xs leading-tight line-clamp-2 group-hover:text-[#E63946] transition-colors">{m.title}</div>
            {m.reason && (
              <div className="mt-1 inline-flex items-center gap-1 text-[10px] text-[#7209B7] font-mono-accent">
                <Sparkle size={10} weight="fill" /> <span className="truncate">{m.reason}</span>
              </div>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
}
